export default {
  SET_CALENDAR_TASK_LIST(state, data) {
    state.calendar_task_list = data
  },
  SET_TASK_STATISTICS(state, data) {
    state.task_statistics = data
  },
  SET_PRIORITIES_LIST(state, data) {
    state.priorities_list = data
  },
  SET_USERS_LIST(state, data) {
    state.users = data
  },
  SET_PROJECTS_LIST(state, data) {
    state.projects = data
  },
  SET_NEW_PROJECT(state, data) {
    state.projects.results.push(data)
  },
  SET_STEPS_LIST(state, data) {
    state.steps = data
  },
  SET_PROJECT_TASKS_LIST(state, data) {
    state.tasks = data
  },
  SET_ALL_TASKS_LIST(state, data) {
    state.all_tasks = data
  },
  SET_ALL_SPRINTS_LIST(state, data) {
    state.sprints = data
  },
  SET_NEW_SPRINTS(state, data) {
    state.sprints.results.push(data)
  },
  SET_NEW_TASK(state, data) {
    state.all_tasks.results.push(data)
  },
  UPDATE_SPRINT(state, data) {
    state.sprints.results = state.sprints.results.map(sprint => {
      if (sprint.id === data.id) {
        return data
      }
      return sprint
    })
  },
  DELETE_SPRINTS(state, id) {
    state.sprints.results = state.sprints.results.filter(sprint => sprint.id !== id)
  },

  UPDATE_ACTIVE_SPRINT(state, data) {
    state.active_sprint = data
  },

  SUPDATE_ONE_TASK(state, data) {
    state.active_sprint.tasks = state.active_sprint.tasks.map(task => {
      if (task.id === data.id) {
        return {
          ...task,
          current_step: {
            ...task.current_step,
            id: data.current_step.id,
          },
        }
      }

      return task
    })
  },

  SET_CLIENTS_LIST(state, data) {
    state.clients = data
  },

  SET_COMMENTS(state, data) {
    state.comments = data
  },

  SET_ONE_TASK(state, data) {
    state.task = data
  },

  ADD_ACTIVE_SPRINT(state, data) {
    console.log(state, data)
  },

  SET_SP_CHART_DATA_BY_DEVS(state, data) {
    state.sp_chart_data_by_devs = data
  },

  SET_TASK_STATISTIC_LIST(state, data) {
    state.task_statistic_list = data
  },
  SET_TASK_MANAGER_LIST(state, data) {
    state.task_manager_list = data
  },

  SET_ATTACHMENT_FILES(state, data) {
    state.attachments = data
  },

}
